// extracted by mini-css-extract-plugin
export default {"h2":"styles_h2__NwT7I","contentCenter":"styles_contentCenter__WscsM","buttonShare":"styles_buttonShare__grTbZ"};